import { cn } from '@invent/wl-ui-kit-next';
import { TriangleAlert } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * A soft finding as the form says it (the survey review's R11): a warning — worth a look, not
 * wrong — set apart from help text and from a hard finding's plain line by a mark and a wash.
 *
 * The colours are the design's `attention` tone (`StatusChip`: "needs a look, not wrong"), so a
 * warning here and a chip elsewhere mean one thing. Not amber, which the brand has none of, and
 * not the guideline Yellow, which marks invented data and test environments (the plan's Q1).
 * `data-finding-severity="soft"` is the hook; "Warning:" says it to a screen reader.
 */
export function WarningLine({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <p
      data-finding-severity="soft"
      className={cn(
        'flex items-start gap-1.5 rounded-md border px-2.5 py-1.5 text-sm',
        'border-[color-mix(in_srgb,var(--color-deep-magenta)_35%,white)] bg-[color-mix(in_srgb,var(--color-magenta)_8%,white)] text-[var(--color-deep-magenta)]',
        className
      )}
    >
      <TriangleAlert aria-hidden className="mt-0.5 size-4 shrink-0" />
      <span>
        <span className="sr-only">Warning: </span>
        {children}
      </span>
    </p>
  );
}
